// /**
//  *  @class
//  *  @function ProductRecommendations
//  */
// class ProductRecommendations extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.parent = this.closest('.product-recommendations--parent');

// 	}
// 	fetchProducts() {
// 		fetch(this.dataset.url)
// 			.then(response => response.text())
// 			.then(text => {
// 				const html = document.createElement('div');
// 				html.innerHTML = text;
// 				const recommendations = html.querySelector('product-recommendations');

// 				if (recommendations && recommendations.innerHTML.trim().length) {
// 					this.innerHTML = recommendations.innerHTML;
// 					if ( this.parent ) {
// 						this.parent.classList.add('product-recommendations--full');

// 						if ( OverlayManager.isOpen(document.getElementById('Cart-Drawer'))) {
// 							this.parent.classList.add('active');
// 						}
// 					}

// 				}

// 				this.classList.add('product-recommendations--loaded');

// 			})
// 			.catch(e => {
// 				console.error(e);
// 			});
// 	}
// 	connectedCallback() {
// 		this.fetchProducts();
// 	}
// }

// customElements.define('product-recommendations', ProductRecommendations);

/**
 * @class
 * @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');
		this.flickity = null;
	}

	fetchProducts() {
		fetch(this.dataset.url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div');
				html.innerHTML = text;

				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					// Inject fetched HTML
					this.innerHTML = recommendations.innerHTML;

					if (this.parent) {
						this.parent.classList.add('product-recommendations--full');

						if (
							typeof OverlayManager !== 'undefined' &&
							OverlayManager.isOpen(document.getElementById('Cart-Drawer'))
						) {
							this.parent.classList.add('active');
						}
					}

					// Wait until DOM is painted and images are loaded
					this.waitForImages().then(() => {
						this.initFlickity();
					});
				}

				this.classList.add('product-recommendations--loaded');
			})
			.catch((error) => {
				console.error('Product recommendations error:', error);
			});
	}

	waitForImages() {
		const images = this.querySelectorAll('img');

		if (!images.length) {
			return Promise.resolve();
		}

		const promises = Array.from(images).map((img) => {
			return new Promise((resolve) => {
				if (img.complete) {
					resolve();
				} else {
					img.addEventListener('load', resolve, { once: true });
					img.addEventListener('error', resolve, { once: true });
				}
			});
		});

		return Promise.all(promises).then(
			() =>
				new Promise((resolve) => {
					requestAnimationFrame(() => {
						requestAnimationFrame(resolve);
					});
				})
		);
	}

	initFlickity() {
	const productList = this.querySelector('.products');

	if (!productList) return;

	// Prevent duplicate initialization
	if (productList.classList.contains('flickity-enabled')) return;

	// Ensure Flickity is available
	if (typeof Flickity === 'undefined') {
		console.warn('Flickity is not loaded.');
		return;
	}

	this.flickity = new Flickity(productList, {
		cellSelector: '.columns',
		cellAlign: 'left',
		contain: true,
		groupCells: false,
		wrapAround: false,
		pageDots: false,
		prevNextButtons: true,
		imagesLoaded: true,
		lazyLoad: 2,
		draggable: true,
		freeScroll: false,
		selectedAttraction: 0.015,
		friction: 0.25,
		watchCSS: false,
		resize: true,

		// Custom SVG arrows
		arrowShape: {
			x0: 15, // start horizontal line
			x1: 5,  // end horizontal line
			y1: 10, // center line
			x2: 10, // top arrow point
			y2: 5,
			x3: 10, // bottom arrow point
			y3: 15
		}
	});

	// Replace default Flickity buttons with custom markup
	this.renderCustomArrows();

	// Force layout recalculation
	setTimeout(() => {
		if (this.flickity) {
			this.flickity.resize();
			this.flickity.reposition();
		}
	}, 100);
}

renderCustomArrows() {
	const prevButton = this.querySelector('.flickity-prev-next-button.previous');
	const nextButton = this.querySelector('.flickity-prev-next-button.next');

	if (prevButton) {
		prevButton.classList.add('flickity-nav', 'flickity-prev');
		prevButton.innerHTML = `
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M17.5 10L2.5 10"
					stroke="#1A1919"
					stroke-width="1.66667"
					stroke-linecap="round"
					stroke-linejoin="round" />
				<path d="M8.33398 4.16663L2.50065 9.99996L8.33399 15.8333"
					stroke="#1A1919"
					stroke-width="1.66667"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>
		`;
	}

	if (nextButton) {
		nextButton.classList.add('flickity-nav', 'flickity-next');
		nextButton.innerHTML = `
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M2.5 10L17.5 10"
					stroke="#1A1919"
					stroke-width="1.66667"
					stroke-linecap="round"
					stroke-linejoin="round" />
				<path d="M11.666 4.16663L17.4994 9.99996L11.666 15.8333"
					stroke="#1A1919"
					stroke-width="1.66667"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>
		`;
	}
}

	connectedCallback() {
		this.fetchProducts();
	}

	disconnectedCallback() {
		if (this.flickity) {
			this.flickity.destroy();
			this.flickity = null;
		}
	}
}

customElements.define('product-recommendations', ProductRecommendations);